"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _wlUtils = require("@utils/wl-utils");
/* 挂载组件 */
var _default = exports.default = function _default(Vue /* , options */) {
  var req = require
  /* 正则匹配路径，中间的范围数字表示目录的层级，最多进一层目录 */.context('./', true, /^(\.\/)([\w-])+(\/{0,1})([\w-])+(.vue)$/);
  req
  /* 获取匹配到的文件 */.keys()
  /* 获取组件 */.map(function (url) {
    return req(url).default;
  })
  /* 过滤掉没有 name 参数的组件 */.filter(function (component) {
    return component.name;
  })
  /* 挂载组件 */.forEach(function (component) {
    return Vue.component((0, _wlUtils.handleNameRule)(component.name, 'ucc'), component);
  });

  // console.log(req.keys(), { ...Vue }.options.components)
};